import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import "./Admin/admin.css";
import Button from 'react-bootstrap/Button';
import MoneyMgmtTopicCard from './money_mgmt_topic_card';
import summarizeTestByTopic from './objects/summarize_test_by_topic';

class MoneyMgmtTestByTopicModal extends Component {
  constructor(props) {
    super(props);
    this.state={
        newFilter: false,
      }    
    this.topicArr = [];
    this.prepareMoneyMgmtTestReport();
}

prepareMoneyMgmtTestReport(){
    this.playerTestData = JSON.parse(JSON.stringify(this.props.financialLiteracyTestArr));
    this.reformatTestRecords();
    this.topicArr = summarizeTestByTopic(this.questionAnswerArr);
}

reformatTestRecords(){
     this.questionAnswerArr = [];
     for (let i=0; i<this.playerTestData.length; i++){
        let questionAnswerArr = this.playerTestData[i].questionAnswerArr;
        const user = this.playerTestData[i].user;
        questionAnswerArr.forEach(item => {
          item.user = user;
        });
        this.questionAnswerArr = this.questionAnswerArr.concat(questionAnswerArr);
     }
}

filterTestReport(filterValue){
    this.playerTestData = JSON.parse(JSON.stringify(this.props.financialLiteracyTestArr));
    if (filterValue === "all"){
       //  no filter applied
    }else{
        this.playerTestData = this.playerTestData.filter(elem => elem.testType === filterValue);
    }
    this.reformatTestRecords();
    this.topicArr = summarizeTestByTopic(this.questionAnswerArr);
    this.setState({newFilter: !this.state.newFilter});
}

render() {
   let accountNbr = "";
    if (this.props.accountNbr){
        accountNbr = this.props.accountNbr;
    }
    let accountName = "";
    if (this.props.accountName){
       accountName = this.props.accountName;
    }
    this.moneyMgmtQuestions = this.topicArr.map((questionInfo, index) =>
      <MoneyMgmtTopicCard questionInfo={questionInfo}  key={index} 
        />
          );
              
return <>
    <Modal className="text-center" show={this.props.openModal}  onHide={() => this.props.onClose()} 
       size="lg" scrollable="true" animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton>
            <Modal.Title className="w-100 text-center pe-4">
                Financial Literacy Topic Summary - Total Number of Tests: &nbsp;
                  {this.playerTestData.length}
                {accountNbr ?
                    <div><b>Selected Account: </b>{accountNbr} - {accountName}</div>
                  :
                    null
                }
            </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
              <span>
                <div className="text-right backgroundTopBottom">
                    <div className="align-items-center mr-5">
                      <label className="font-weight-bold ml-2" htmlFor="testType"
                        style={{ whiteSpace: "nowrap" }}>
                        Filter By Test Type:
                      </label>
                      <select className="filter-select small-select" id="testType"
                        onChange={(val) => this.filterTestReport(val.target.value)} >
                        <option value="all">no filter applied</option>
                        <option value="pre-test">pre-test</option>
                        <option value="mid-test">mid-test</option>
                        <option value="post-test">post-test</option>
                      </select>
                    </div>
                </div>
              <div className="backgroundTopBottom mt-2"></div>
              <table className="table table-no-space table-hover mx-0">
                <tbody>
                  <tr className="header-sticky">
                    <th>Topic Name</th>
                    <th>Nbr Questions</th>
                    <th>Number Fully Correct</th>
                    <th>Percent Correct</th>
                    <th>Number Partially Correct</th>
                  </tr>
                  {this.moneyMgmtQuestions}
                </tbody>
              </table>
              <div className="mx-5 mt-4 text-left">
                  *** Nbr Partially Correct indicates the number of students that got partial
                  credit for their answer(s) to the questions for this topic.
              </div>        
              </span>
                  
        </Modal.Body>
        <Modal.Footer className="backgroundTopBottom p-0" >
             
              <Button variant="primary"  onClick={() => this.props.onClose()}>
                   Close
              </Button>
              
        </Modal.Footer>
       
    </Modal>
    
  </>
  }
}

export default MoneyMgmtTestByTopicModal;